import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { fileUrl } from "../../lib/api";

export function ParallaxReel({ items = [] }) {
  const trackRef = useRef(null);
  const EXCLUDE = ["IMG_9467", "IMG_9470", "pexels-photo-2192237"];
  const seen = new Set();
  const slides = items
    .filter((p) => p.image && !EXCLUDE.some((x) => p.image.includes(x)))
    .filter((p) => {
      const base = p.image.split("/").pop().replace(/-[0-9a-f]{6,}-/i, "-").replace(/-\d+w\..*$/i, "").replace(/\.[^.]+$/, "");
      if (seen.has(base)) return false;
      seen.add(base);
      return true;
    });
  if (!slides.length) return null;

  const step = (dir) => {
    const track = trackRef.current;
    const card = track && track.children[0];
    if (!track || !card) return;
    const amount = card.offsetWidth + 24; // card width + gap-6 (24px)
    const max = track.scrollWidth - track.clientWidth;
    let next = track.scrollLeft + dir * amount;
    if (next > max - 4) next = 0;
    if (next < 0) next = max;
    track.scrollTo({ left: next, behavior: "smooth" });
  };

  return (
    <section data-testid="parallax-reel" className="py-24 border-b border-ash overflow-hidden">
      <div className="flex flex-wrap items-end justify-between gap-6 px-5 sm:px-8 lg:px-12 mb-10">
        <h2 className="display text-6xl lg:text-8xl text-white">Recent Work</h2>
        <div className="flex items-center gap-3">
          <button onClick={() => step(-1)} data-testid="reel-prev" aria-label="Previous" className="w-12 h-12 rounded-full border border-ash text-white flex items-center justify-center hover:border-violet hover:text-violet transition-colors">
            <ArrowLeft size={18} />
          </button>
          <button onClick={() => step(1)} data-testid="reel-next" aria-label="Next" className="w-12 h-12 rounded-full border border-ash text-white flex items-center justify-center hover:border-violet hover:text-violet transition-colors">
            <ArrowRight size={18} />
          </button>
        </div>
      </div>

      <div ref={trackRef} className="flex gap-6 px-5 sm:px-8 lg:px-12 overflow-x-auto snap-x snap-mandatory pb-2 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {slides.map((p, i) => (
          <button
            key={p.id}
            onClick={() => step(1)}
            data-testid={`reel-card-${i}`}
            className="group relative shrink-0 w-[80vw] sm:w-[54vw] lg:w-[40vw] border border-ash overflow-hidden snap-start"
          >
            <div className="mono-hover img-zoom relative aspect-[16/10] overflow-hidden">
              <img src={fileUrl(p.image)} alt="Tattoo work by Obsidian Art & Tattoo Studio" loading="eager" className="w-full h-full object-cover" />
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
